module.exports = __webpack_public_path__ + "static/jumbotron-c909be3f6ff771026adf0438c181f4d5.jpg";